import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { MenuBook as MenuBookIcon } from '@mui/icons-material';
import QuestionSetFormBase from '../../components/forms/QuestionSetFormBase';
import * as api from '../../api/questionSetApi';
import { extractQuestionSetId } from '../../utils/apiHelpers';

const ReadingQuestionSetForm = () => {
  const { readingId, questionSetId } = useParams();
  const location = useLocation();
  const { passage } = location.state || { passage: 'passage1' };

  return (
    <QuestionSetFormBase
      parentId={readingId}
      questionSetId={questionSetId}
      section={passage}
      sectionKey="passage"
      sectionOptions={['passage1', 'passage2', 'passage3']}
      sectionLabel="Passage"
      icon={MenuBookIcon}
      basePath="/readings"
      api={api}
      extractQuestionSetId={extractQuestionSetId}
    />
  );
};

export default ReadingQuestionSetForm;
